import React from 'react';
import { View, Text, ScrollView, StyleSheet } from 'react-native';
import { MAIN_BG_COLOR } from './common';
import StylePropertyField from './StylePropertyField';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { mdiMenuDown } from '@mdi/js';
import Icon from '@mdi/react';

const accordionIcon = <Icon path={mdiMenuDown} size={0.7} />;

export default function CustomStyleManager({ type, sectors }) {
  return (
    <ScrollView style={{ maxHeight: "80vh" }} style={styles.container}>
      {sectors.map((sector) => (
        <Accordion key={sector.getId()} disableGutters>
          <AccordionSummary
            style={{ backgroundColor: 'rgb(90,192,234)', borderTopLeftRadius: 20, borderBottomLeftRadius: 20 }}
            expandIcon={accordionIcon}
          >
            <Text style={[styles.sectorName, { color: "white" }]}>{sector.getName()}</Text>
          </AccordionSummary>
          <AccordionDetails style={styles.details}>
            {sector.getProperties().map((prop) => (
              <StylePropertyField key={prop.getId()} prop={prop} />
            ))}
          </AccordionDetails>
        </Accordion>
      ))}
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  sectorName: {
    color: 'rgb(90,192,234)',
    fontWeight: 'bold',
  },
  details: {
    flexDirection: 'column',
    gap: 10,
  },
});
